export default function PageNotFound() {
  return (
    <>
      <div className="page-not-found flex min-h-full flex-col">
        <main className="page-not-found__container mx-auto flex w-full max-w-7xl flex-auto flex-col justify-center px-6 py-24 sm:py-64 lg:px-8">
          <p className="page-not-found__error-code text-base font-semibold leading-8 text-indigo-600">404</p>
          <h1 className="page-not-found__title mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">Page not found</h1>
          <p className="page-not-found__message mt-6 text-base leading-7 text-gray-600">Sorry, we couldn't find the page you're looking for.</p>
        </main>
      </div>
    </>
  );
}